/**
 *
 * ModalContent
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthModalState } from 'containers/Auth/actions';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { getRequiredExtraData } from 'components/SAMLButton/utils';
import { updateAccountResult as updateAccountResultAction } from 'containers/Account/actions';
import { makeSelectUpdateAccountResult } from 'containers/Account/selectors';
import { getParentPosition } from 'utils/embedded';
import ModalExtraData from './ModalExtraData';
import ModalLogin from './ModalLogin';
import ModalSignUp from './ModalSignUp';
import ModalSubscription from './ModalSubscription';

const ModalContent = ({
  action,
  onClose,
  onSignUp,
  profile,
  type,
  storedItemPayload,
}) => {
  const dispatch = useDispatch();
  const clientDetails = useSelector(makeSelectClientDetails());
  const updateAccountResult = useSelector(makeSelectUpdateAccountResult());
  const [signedProfile, setSignedProfile] = useState(
    profile.isEmpty ? undefined : profile,
  );
  const [embedParentPosition, setEmbedParentPosition] = useState({});

  useEffect(() => {
    let isMounted = true;

    const fetchAndSetParentPosition = async () => {
      const parentPosition = await getParentPosition();
      if (isMounted) {
        setEmbedParentPosition(parentPosition);
      }
    };

    fetchAndSetParentPosition();

    return () => {
      isMounted = false;
    };
  }, []);

  const isLogin = action !== 'sign-up';

  useEffect(() => {
    if (_isEmpty(signedProfile) && !profile.isEmpty) {
      setSignedProfile(profile);
    }
  }, [profile, signedProfile]);

  useEffect(() => {
    if (!_isEmpty(updateAccountResult)) {
      setSignedProfile(profile);
      dispatch(setAuthModalState({ show: false, type: '' }));

      return () => dispatch(updateAccountResultAction({}));
    }
    return () => {};
  }, [dispatch, profile, updateAccountResult]);

  if (
    !_get(signedProfile, 'isEmpty', true) &&
    _get(signedProfile, 'providerData.providerId') !== 'password' &&
    getRequiredExtraData(signedProfile).length > 0
  )
    return <ModalExtraData onClose={onClose} profile={signedProfile} />;

  if (
    !_get(signedProfile, 'isEmpty', true) &&
    _get(signedProfile, 'providerData.providerId') !== 'password' &&
    !_get(clientDetails, 'metadata.hideSubscription') &&
    !_get(clientDetails, 'metadata.requirePersonalEmail')
  )
    return <ModalSubscription onClose={onClose} />;

  const embedPositionTop = _get(embedParentPosition, 'top', null);
  const positionTop = embedPositionTop ? `${embedPositionTop}px` : '5%';

  return isLogin ? (
    <ModalLogin
      onClose={onClose}
      onSignUp={onSignUp}
      type={type}
      positionTop={positionTop}
    />
  ) : (
    <ModalSignUp
      storedItemPayload={storedItemPayload}
      onClose={onClose}
      onSignUp={onSignUp}
      type={type}
      positionTop={positionTop}
    />
  );
};

ModalContent.propTypes = {
  action: PropTypes.string,
  onClose: PropTypes.func,
  onSignUp: PropTypes.func,
  profile: PropTypes.object,
  type: PropTypes.string,
};

export default ModalContent;
